import { render, staticRenderFns } from "./AddonSectionManage.vue?vue&type=template&id=63a7d9c4&scoped=true&"
import script from "./AddonSectionManage.vue?vue&type=script&lang=js&"
export * from "./AddonSectionManage.vue?vue&type=script&lang=js&"
import style0 from "./AddonSectionManage.vue?vue&type=style&index=0&id=63a7d9c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a7d9c4",
  null
  
)

export default component.exports